import React from "react";
import { NavLink } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import "./SideMenu.css";
import homeIcon from "../../assets/icons/home.svg";
import recordIcon from "../../assets/icons/record.svg";
import settingIcon from "../../assets/icons/setting.svg";
import learnerIcon from "../../assets/icons/learner.svg";
import signoutIcon from "../../assets/icons/signout.svg";
import QuizGenie from "../../assets/images/QuizGenie.png";
import { RxCross2 } from "react-icons/rx";

const Sidebar = ({ isMobile, toggleSidebar }) => {
    const { themeStyles } = useTheme();

    return (
        <div
            className="sidebar"
            style={{
                background: themeStyles.sidebarBackgroundColor,
                color: themeStyles.text,
            }}
        >
            {/* Logo and Title */}
            <div className="sidebar-header">
                <img alt="" src={QuizGenie} height={120} width={120} style={{ position: 'absolute', borderRadius: 20, marginTop: isMobile ? 30 : "0" }} />
            </div>

            <button onClick={toggleSidebar}>
                {isMobile && <RxCross2 onClick={() => toggleSidebar} style={{ position: 'absolute', right: 20, top: 23, fontSize: 35, color: "#FFF" }} />}
            </button>



            {/* Navigation Links */}
            <nav className="sidebar-links">
                <NavLink
                    to="/question-creator"
                    className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
                >
                    <img src={homeIcon} alt="Home Icon" className="sidebar-icon" />
                    <span style={{ fontSize: 22 }}>AI Quiz</span>
                </NavLink>

                <NavLink
                    to="/learners"
                    className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
                >
                    <img src={learnerIcon} alt="Learners Icon" className="sidebar-icon" />
                    <span style={{ fontSize: 22 }}>Learner</span>
                </NavLink>

                <NavLink
                    to="/record"
                    className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
                >
                    <img src={recordIcon} alt="Records Icon" className="sidebar-icon" />
                    <span style={{ fontSize: 22 }}>Record</span>
                </NavLink>

                <NavLink
                    to="/setting"
                    className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
                >
                    <img src={settingIcon} alt="Settings Icon" className="sidebar-icon" />
                    <span style={{ fontSize: 22 }}>Setting</span>
                </NavLink>
            </nav>

            {/* Footer with Sign Out */}
            <div className="sidebar-footer">
                <NavLink
                    to="/login"
                    className={({ isActive }) => `sidebar-link sign-out ${isActive ? "active" : ""}`}
                >
                    <img src={signoutIcon} alt="Settings Icon" className="sidebar-icon" />
                    <span>Sign Out</span>
                </NavLink>
            </div>
        </div>
    );
};

export default Sidebar;
